import FrontFooter from '../../front/components/FrontFooter';
import FrontNav from '../../front/components/FrontNav';

function About() {
  return (
    <div className="front">
      <FrontNav />

      <FrontFooter />
    </div>
  );
}

export default About;
